
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-us",
      function () {
        return require("private-next-pages/why-us.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-us"])
      });
    }
  